import styled from 'styled-components';

export const RuleDisplayTimeStyled = styled.div`
  .Polaris-Choice {
    width: 100%;
    &__Label {
      width: 100%;
    }
  }
  .Polaris-Select {
    min-width: 57px;
  }

  .date-time-select {
    display: flex;
    align-items: center;
    gap: 8px;
    &__container {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    @media (max-width: 450px) {
      align-items: start;
      &__container {
        flex-direction: column;
      }
    }
  }
`;
